import { apiClient } from './client';
import type { ApiResponse } from './types';
import type { PlatformAdmin } from '../store/auth';

export interface LoginInput {
  username: string;
  password: string;
}

export interface LoginResult {
  token: string;
  admin: PlatformAdmin;
}

export async function login(body: LoginInput): Promise<LoginResult> {
  const r = await apiClient.post<ApiResponse<LoginResult>>('/auth/login', body);
  return r.data.data!;
}
